import {UploadedFile} from '@interfaces/file.interface';

export namespace WorkingObjectNamespace {
    export interface Interface {
        id: number;
        /**
         * Наименование объекта
         */
        name: string;
        status: Status;

        /**
         * Организация заказчик
         */
        org_customer: string;

        /**
         * Дата начала работ
         */
        date_begin: string;

        /**
         * Дата окончания работ
         */
        date_end: string;

        /**
         * Руководитель работ
         */
        leader_id: number;
        leader: {name: string; job: string};

        /**
         * Место проведения работ
         */
        place: {
            id: number;
            name: string;
            address: string;
            lat: number;
            lng: number;
        };

        /**
         * Примечание
         */
        notice: string;

        /**
         * Работы проводятся без договора
         */
        no_order: boolean;

        requirements: Requirement[];
        work_types: WorkType[];
        orders: Order[];

        /**
         * Просрочена ли дата окончания
         */
        _is_expired: boolean;
    }

    /**
     * Интерфейс объекта для просмотра в списке
     */
    export interface ListItem {
        id: number;
        name: string;
        org_customer: string;
        leader: {name: string; job: string};
        status: string;
        date_begin: string;
        date_end: string;
        _is_expired: boolean;
    }

    /**
     * Требования к проведению работ
     */
    export interface Requirement {
        id: number;
        name: string;
        checked: boolean;
    }

    /**
     * Виды проводимых на объекте работ
     */
    export interface WorkType {
        id: number;

        /**
         * Наименование работ
         */
        name: string;

        /**
         * Работа выбрана для объекта
         */
        checked: boolean;

        /**
         * Работа залокирована для выбора?
         */
        disabled: boolean;
    }

    /**
     * Параметры договора
     */
    export interface Order {
        id: number;

        /**
         * Дата подписания договора
         */
        signing_date: string;

        /**
         * Номер договора
         */
        number: string;
        files: UploadedFile[];
    }

    /**
     * Статусы состояния объектов
     */
    export enum Status {
        /**
         * Новый объект
         */
        new = 1,

        /**
         * Объект находится в работе
         */
        inWork = 2,

        /**
         * Работы завершены, с объекта убрано все оборудование и выведены специалисты, документы переданы заказчику
         */
        worksEnded = 3,

        /**
         * Объект сдан, деньги получены
         * По сути полное завершение объекта
         */
        complete = 4,
    }
}
